import server from "./server";

export const getHomeDataApi = async () => {
  const response = await server().get(`/dashbordHome`);
  return response.data;
};
